<style>
 @import '@/assets/css/swiper-bundle.min.css';
 @import '@/assets/css/styles.css';
</style>

<template>
  <master></master>
</template>

<script>
import Master from "./views/MasterView.vue"

export default {
  components: {Master},
  async mounted() {
    const Swiper = await import('@/assets/js/swiper-bundle.min.js');
    window.Swiper = Swiper.default || Swiper;
    await import('@/assets/js/main.js');
  }
};
</script>